export default {"src":"https://images-cdn.curipod.com/d-3b4784cd/_next/static/media/feide-logo.aab537d8.ico","height":48,"width":48};